/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { compile } from 'path-to-regexp';
import { Message } from 'element-ui';
import { API_BASE } from '@/config';
import { AUTH_TOKEN } from '@/data/auth';
import store from '@/store';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { showFullScreenLoading, hideFullScreenLoading } from './request-helper';

export const getToken = () => {
  try {
    return window.localStorage.getItem(AUTH_TOKEN) || '';
  } catch (e) {
    return '';
  }
};

export const removeToken = () => {
  try {
    window.localStorage.removeItem(AUTH_TOKEN);
  } catch (e) {
    console.error(e);
  }
};

const { CancelToken } = axios;
const promiseArr = {}; // 正在发起请求队列
// const TIME_OUT = 50000; // 超时设置
// 跳转登录页面 code

const request = (defaults = {}) => {
  // create an axios instance
  const instance = axios.create({
    headers: {
      'Content-Type': defaults.contentType || 'application/json;charset=utf-8',
      'bb-flow-tag': 'bb-client',
    },
    // timeout: defaults.timeout || TIME_OUT,
    cache: false, // Whether to cache
    withCredentials: true, // send cookies when cross-domain requests
  });

  // request interceptor
  instance.interceptors.request.use(
    (config) => {
      // 显示 loading
      if (defaults.loading) {
        const message = defaults.loadingMessage;
        showFullScreenLoading(message);
      }

      // 处理完整的 URL. 非 http, https 的才处理
      const isExternal = /^(https?:)/.test(config.url);
      if (!isExternal) {
        const hasServer = !!API_BASE[defaults.server];
        if (!hasServer) {
          console.warn(
            `API_BASE not found 'server: ${defaults.server}' config, will reset server to 'base'`,
          );
          defaults.server = 'base';
        }
        if (config.appendApmPrefix !== false) {
          config.url = `${API_BASE[defaults.server]}/apm${config.url}`;
          // config.url = `http://10.25.1.70:8080${config.url}`;
        } else {
          // config.url = `http://10.25.2.39:8080${config.url}`;
          config.url = `${API_BASE[defaults.server]}${config.url}`;
        }
        // 判断当前的链接
        // config.url = `http://10.25.8.92:3000${config.url}`;
      }

      const METHOD = config.method.toLowerCase();

      // 发起请求时，取消掉当前正在进行的相同请求
      let promiseArrKey = config.url;
      const _data = { ...config.data };
      delete _data._;
      const _params = { ...config.params };
      delete _params._;

      if (defaults.isCancelDuplicateUrlRequests) {
        promiseArrKey += METHOD;
      } else {
        if (JSON.stringify(_data) !== '{}') {
          promiseArrKey += `&${JSON.stringify(_data)}`;
        }
        if (JSON.stringify(_params) !== '{}') {
          promiseArrKey += `&${JSON.stringify(_params)}`;
        }
      }

      config.promiseArrKey = promiseArrKey;

      if (promiseArr[promiseArrKey] && !defaults.isNotCancel) {
        promiseArr[promiseArrKey]('Cancel operation');
      }
      promiseArr[promiseArrKey] = defaults.cancelFn;

      config.headers.OSChannel = 'web'; // 平台标识
      config.headers['req-agent'] = 'apm'; // 系统标识

      let keyName = 'params';
      if (['post', 'put'].includes(METHOD)) {
        keyName = 'data';
      }

      // isHideCommonParams，是否隐藏通用参数
      // 公共接口不用通用参数
      if (!config.isHideCommonParams) {
        config[keyName].bizChannel = store.getters['app/bizChannel'];
        config[keyName].env = store.getters['app/env'];
        if (router.history.current?.meta?.isUseServerInfo || false) {
          config[keyName].serverName = store.getters['app/serverName'];
        } else {
          config[keyName].source = store.getters['app/source'];
        }
      }

      // GET 请求设置时间戳参数, 解决缓存问题
      if (METHOD === 'get' && !config.cache) {
        config.params._ = Date.now();
      }

      // 增加token
      const token = getToken();

      if (token) {
        config.headers['paas-token'] = token;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  // response interceptor
  instance.interceptors.response.use(
    async (response) => {
      delete promiseArr[response.config.promiseArrKey];
      hideFullScreenLoading();
      const { data } = response;
      if (response.config.responseType.toLowerCase() === 'blob') {
        return Promise.resolve(response);
      }
      const {
        code, message,
      } = data;
      if (code === 200 || code === '200') {
        return Promise.resolve(data);
      }
      // 登录失效
      if (code === 605) {
        removeToken();
        router.replace({
          name: 'Login',
        });
      } else {
        Message.closeAll();
        Message({
          type: 'error',
          message,
        });
      }
      return Promise.reject(data);
    },
    async (error) => {
      hideFullScreenLoading();

      if (error && error.response) {
        const messages = {
          400: '错误请求',
          401: '会话过期，请重新登录',
          403: '拒绝访问',
          404: '请求错误，未找到该资源',
          405: '请求方法未允许',
          408: '请求超时',
          500: '服务器端出错',
          501: '网络未实现',
          502: '网络错误',
          503: '服务不可用',
          504: '网络超时',
          505: 'http版本不支持该请求',
        };
        error.message = messages[error.response.status] || `连接错误${error.response.status}`;
      } else {
        error.message = error.message || '连接到服务器失败';
      }

      try {
        const { status, statusText } = error.response;
        // 登录过期
        if (status === 401) {
          // 关闭所有 Message 实例
          Message.closeAll();
          router.replace({
            name: 'Login',
          });
          return Promise.reject(error);
        }

        // 非登录过期错误
        Message({
          type: 'error',
          message: `${status} - ${error.message}`,
        });

        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          status,
          statusText,
          message: error.message,
        });
      } catch (err) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          status: 'canceled',
          statusText: 'Cancel operation',
          message: error.message,
        });
      }
    },
  );

  return instance(defaults);
};

/*
 * url 地址
 * params 查询参数
 * data 提交内容
 * config axios 配置
 * loading=false 是否显示 loading
 * loadingMessage='加载中...' loading 信息提示
 *  responseType 默认 json
 * isCancelDuplicateUrlRequests 取消重复url 请求（不包含参数）
 * isCancelDuplicateUrlRequests 取消重复url 请求（不包含参数）
 * errorMessageCallback 不显示默认提示信息（返回true 不显示）
 * */
const defaultConfig = {
  server: 'base',
  url: '',
  params: {},
  data: {},
  config: {},
  loading: false,
  loadingMessage: '加载中...',
  responseType: 'json',
  isCancelDuplicateUrlRequests: false,
  errorMessageCallback: () => {},
  isNotCancel: false,
};

/* eslint-disable object-curly-newline */
const http = {
  /**
   * GET 请求
   * @param {*} [config={}] axios 配置
   * @param paramsSerializer
   * @param requestConfig 其他配置详情查看 defaultConfig
   * @returns
   */
  get({ config = {}, paramsSerializer = {}, ...requestConfig }) {
    const { params = {}, data = {}, ...rest } = requestConfig;
    const mergeConfig = {
      ...defaultConfig,
      ...rest,
      params,
      data,
      method: 'GET',
      paramsSerializer: (paramsData) => qs.stringify(paramsData, paramsSerializer),
      ...config,
    };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });

    return request(mergeConfig);
  },

  /**
   * POST 请求
   * @param {*} [config={}] axios 配置
   * @param requestConfig 其他配置详情查看 defaultConfig
   * @return {*}
   */
  post({ config = {}, ...requestConfig }) {
    const { params = {}, data = {}, ...rest } = requestConfig;
    const mergeConfig = { ...defaultConfig, ...rest, params, data, method: 'POST', ...config };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });
    return request(mergeConfig);
  },

  /**
   * DELETE 请求
   * @param {*} [config={}] axios 配置
   * @param requestConfig 其他配置详情查看 defaultConfig
   * @return {*}
   */
  delete({ config = {}, ...requestConfig }) {
    const { params = {}, data = {}, ...rest } = requestConfig;
    const mergeConfig = {
      ...defaultConfig,
      ...rest,
      params,
      data,
      method: 'DELETE',
      paramsSerializer: (paramsData) => qs.stringify(paramsData),
      ...config,
    };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });

    return request(mergeConfig);
  },

  /**
   * PUT 请求
   * @param {*} [config={}] axios 配置
   * @param requestConfig 其他配置详情查看 defaultConfig
   * @return {*}
   */
  put({ config = {}, ...requestConfig }) {
    const { params = {}, data = {}, ...rest } = requestConfig;
    const mergeConfig = { ...defaultConfig, ...rest, params, data, method: 'PUT', ...config };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });
    return request(mergeConfig);
  },

  /**
   * PATCH 请求
   * @param {*} [config={}] axios 配置
   * @param requestConfig 其他配置详情查看 defaultConfig
   * @return {*}
   */
  patch({ config = {}, ...requestConfig }) {
    const { params = {}, data = {}, ...rest } = requestConfig;
    const mergeConfig = { ...defaultConfig, ...rest, params, data, method: 'PATCH', ...config };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });
    return request(mergeConfig);
  },

  /**
   * 并发请求
   *
   * @param {*} [args=[]] 请求数组
   * @returns
   */
  all: (args = []) => axios.all(args),

  fetch(method, url, data, config) {
    const { params = {}, query = {}, body = {} } = data;
    const mergeConfig = {
      ...defaultConfig,
      url: compile(url)(params),
      params: query,
      data: body,
      method,
      paramsSerializer: (paramsData) => qs.stringify(paramsData, { arrayFormat: 'repeat' }),
      ...config,
    };

    mergeConfig.cancelToken = new CancelToken((c) => {
      mergeConfig.cancelFn = c;
    });
    return (model, path) => request({ ...mergeConfig, model, path });
  },
};

export default http;
